import React from 'react';
import { Modal } from '@mantine/core';
import Button from '../../elements/Button';
import styles from './styles.scoped.css';
import PropTypes from 'prop-types';
import { clearStorages } from '../../../utils/storage';
import { useNavigate } from 'react-router-dom';

export const ModalExpiredToken = ({
  opened,
  handleRelog,
  title,
  // message = '',
  // setModal = () => {}
}) => {
  const navigate = useNavigate();
  const onConfirm = () => {
    handleRelog();
    clearStorages();
    navigate('/login');
  };
  return(
    <Modal centered onClose={() => {}} opened={opened} withCloseButton={false}>
      <h4 className={styles.titleModal}>{title || 'Waktu Sesi Login Anda Habis'}</h4>
      <div>
        <span>Harap masuk akun kembali untuk mengulangi proses menghubungkan
             aplikasi authenticator dengan akun Anda.</span>
        <br/>
        <Button className={styles.btnRelog} onClick={onConfirm} style={'blue'}>Masuk Ulang</Button>
      </div>
    </Modal>
  );
};

export default ModalExpiredToken;

ModalExpiredToken.propTypes = {
  handleRelog: PropTypes.func,
  message: PropTypes.string,
  opened: PropTypes.bool,
  setModal: PropTypes.func,
  title: PropTypes.string
};
